import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./components/header";
import Home from "./pages/Home";
import Work from "./pages/workdetail";
import TeamSection from "./pages/team";
import ServicesPage from "./pages/servicepage";
import JobsPage from "./pages/jobspage";
import CertificatesPage from "./pages/certificatespage";
import VideosPage from "./pages/videospage";
import Contact from "./pages/contactpage";
import AboutCompany from "./pages/moreinfo";
import WorksPge from "./pages/workspage";
import BranchesPage from "./pages/branchespage";
import { useEffect } from "react"; // ✅ правильно
import { useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to the top when a new location is pushed onto the navigation stack
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="work/:id" element={<Work />} />
            <Route path="team" element={<TeamSection />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="jobs" element={<JobsPage />} />
            <Route path="certificates" element={<CertificatesPage />} />
            <Route path="videos" element={<VideosPage />} />
            <Route path="contact" element={<Contact />} />
            <Route path="about" element={<AboutCompany />} />
            <Route path="works" element={<WorksPge />} />
            <Route path="branches" element={<BranchesPage />} />
          </Route>
        </Routes>
        <ScrollToTop /> {/* лучше ставить тут */}
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
